module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.b826885.eot";